import React, { useEffect, useState } from 'react';
import { useDispatch } from 'react-redux';
import { CheckIcon ,PhotoIcon ,CheckCircleIcon ,XCircleIcon} from "@heroicons/react/24/outline";

import { useTranslation } from 'react-i18next';
import { getCurrencyAndLanguageSymbol } from '../../constent/currencyUtils';

const CustomBuyForMeCard = ({ image, title,status, count,weight, price,isPacking,itemId,cartIsPacking,onShowGallery,images ,isChecked: propChecked, onCheckboxChange }) => {
    const [isHovered, setIsHovered] = useState(false);
    const { t } = useTranslation();
    const [isChecked, setIsChecked] = useState(propChecked ?? isPacking);

  useEffect(() => {
      setIsChecked(isPacking);
    }, [isPacking]);
    
    useEffect(() => {
        if (typeof propChecked === "boolean") {
          setIsChecked(propChecked);
        }
      }, [propChecked]);
    
      const handlePackingCheckboxChange = () => {
        const newValue = !isChecked;
        setIsChecked(newValue);
    
        if (onCheckboxChange) {
          onCheckboxChange(newValue);
        }
      };
  
    const handleMouseEnter = () => {
        setIsHovered(true);
    };

    const handleMouseLeave = () => {
        setIsHovered(false);
    };

    return (
        <div
            onMouseEnter={handleMouseEnter}
            onMouseLeave={handleMouseLeave}
            className="relative flex flex-col items-center justify-between w-full overflow-hidden bg-white border group"
        >
            <div className="relative w-full h-[180px] lg:h-[230px] flex items-center justify-center">
                <img
                    src={image}
                    alt={title}
                    className="object-contain max-w-full max-h-full"
                />
                {images?.length > 0 && (
                    <>
                        {images?.length > 0 &&
                        <div className="absolute flex justify-start w-full gap-2 bottom-2 px-[5%]">
                            <button
                            className="p-2 rounded bg-custom-yellow"
                            onClick={onShowGallery}
                            >
                            <PhotoIcon className="w-4 h-4 text-black" />
                            </button>
                        </div>
                        }
                    </>
                )}
            </div>
            <div
                className={`flex flex-col items-start justify-center gap-2 w-full p-4 transition-colors  duration-300 ${
                    isHovered ? 'bg-black text-white' : 'bg-custom-yellow text-black'
                }`}
            >
                <h2 className="text-sm font-bold text-black duration-300 group-hover:text-white">{title}</h2>
            <div className='flex justify-between w-full text-black duration-300 group-hover:text-white'>
            <p className="text-xs text-black duration-300 group-hover:text-white">{t("Count")} : {count}</p>
            
            </div>
            <p className="text-xs text-black duration-300 group-hover:text-white">{t("Status")} : {t(`${status}`)}</p>
             
            {cartIsPacking && 
                <>
                    <p className="flex items-center gap-2 text-xs ">{t("Packaging")} : {isPacking ?<CheckCircleIcon class="h-6 w-6 text-blue-600" />
                    : <XCircleIcon class="h-6 w-6 text-red-600" /> }</p>
                </>
            }
            
                

            {status === "received" && !cartIsPacking &&
            <>
                <p className="mt-2 text-xs font-bold text-black duration-300 group-hover:text-white lg:text-sm">
                    {weight > 0 ? (
                    <>
                        {t("weight")} : {weight}
                        <span className="text-[9px] text-black"> {t("kg")}</span>
                    </>
                    ) : (
                        <>
                        {t("weight")} : {t("waiting")}
                        </>
                    )}    
                </p>                
                <div className="flex items-center gap-2 mt-2 cursor-pointer"
                    onClick={handlePackingCheckboxChange}
                    >
                    <div
                        className={`relative w-3 h-3 lg:w-5 lg:h-5 rounded flex items-center justify-center border-2 ${
                        isChecked ? "bg-green-600 border-green-600" : "bg-white border-gray-300"
                        }`} 
                    >
                        {isChecked && <CheckIcon className="w-4 h-4 text-white" />}
                        <input
                        type="checkbox"
                        className="absolute inset-0 opacity-0 cursor-pointer "
                        checked={isChecked}
                        onChange={handlePackingCheckboxChange} 
                        />
                    </div>
                    <span className="text-sm font-medium text-black duration-300 group-hover:text-white" >
                        {t("Productpackaging")}
                    </span>
                </div>
            </>
            }
            </div>
        </div>
    );
};

export default CustomBuyForMeCard;
